import React from "react";

class HomeIcon extends React.Component {
  render() {
    return (
      <i className="anticon anticon-profile">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1.18em"
          height="1em"
          viewBox="0 0 18 17"
        >
          <path
            d="M77.834,185.67l-8.471-7.5a0.265,0.265,0,0,0-.048-0.036,0.5,0.5,0,0,0-.677-0.011l-8.471,7.5a0.494,0.494,0,0,0-.041.7,0.508,0.508,0,0,0,.707.041l1.525-1.353v8.744A1.254,1.254,0,0,0,63.617,195H66.29a1.176,1.176,0,0,0,1.181-1.169v-4.445a0.181,0.181,0,0,1,.181-0.18h2.7a0.181,0.181,0,0,1,.181.18v4.445A1.176,1.176,0,0,0,71.714,195h2.673a1.42,1.42,0,0,0,1.259-1.561v-8.381l1.525,1.352A0.5,0.5,0,1,0,77.834,185.67Zm-3.191,2.444v5.318a0.574,0.574,0,0,1-.259.571H71.711a0.18,0.18,0,0,1-.181-0.179v-4.438a1.176,1.176,0,0,0-1.181-1.169h-2.7a1.176,1.176,0,0,0-1.181,1.169v4.445a0.181,0.181,0,0,1-.181.18H63.614a0.259,0.259,0,0,1-.259-0.257v-9.63l5.62-4.969,5.668,5.016v3.943h0Z"
            transform="translate(-60 -178)"
            fill="currentColor"
          />
        </svg>
      </i>
    );
  }
}

export default HomeIcon;
